import { FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { QuestionCard } from '@empathy/survey/base';

export const ChoiceValidator =
  (requiredInd: boolean, useOtherInd: boolean): ValidatorFn =>
  (group: FormGroup): ValidationErrors | null => {
    const isEmpty = !group.get('value').value || group.get('value').value.length === 0;
    if (isEmpty) {
      return requiredInd ? { required: true } : null;
    }

    if (!useOtherInd) {
      return null;
    }

    const isOtherSelected = group.get('value').value === 'OTHER' || group.get('value').value.includes('OTHER');
    const otherTextValue = group.get('otherText').value || '';
    const isOtherTextEmpty = otherTextValue.trim().length === 0;

    if (isOtherSelected && isOtherTextEmpty) {
      return { requiredOtherText: true };
    }

    return null;
  };

export const RequiredIfVisible =
  (questionCard: QuestionCard): ValidatorFn =>
  (ctrl: FormControl): ValidationErrors | null => {
    const isEmpty = !ctrl.value || ctrl.value.length === 0;
    if (isEmpty && questionCard.visible) {
      return { required: true };
    }

    return null;
  };

export const MinMaxAreas =
  (min: number, max: number): ValidatorFn =>
  (ctrl: FormControl): ValidationErrors | null => {
    if (min === 0 && max === 0) {
      return null;
    }

    if (ctrl.value) {
      const values = JSON.parse(ctrl.value);
      if (min > 0 && values.length < min) {
        return { minAreas: min };
      }

      if (max > 0 && values.length > max) {
        return { maxAreas: max };
      }
    }

    return null;
  };

export const MinMaxFiles =
  (min: number, max: number): ValidatorFn =>
  (ctrl: FormArray): ValidationErrors | null => {
    if (min === 0 && max === 0) {
      return null;
    }

    if (ctrl.length < min) {
      return { minFiles: min };
    }

    if (max !== 0 && ctrl.length > max) {
      return { maxFiles: max };
    }

    return null;
  };

export const AiChatAnswered =
  (requiredInd: boolean): ValidatorFn =>
  (ctrl: FormArray): ValidationErrors | null => {
    if (!requiredInd) {
      return null;
    }

    const hasParticipantAnswer = ctrl.controls.some((prompt) => {
      const answerText = prompt.get('answerText')?.value;
      return typeof answerText === 'string' && answerText.trim().length > 0;
    });

    return hasParticipantAnswer ? null : { required: true };
  };
